import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import pendingPromise from 'utils/pendingPromise';

import s from 'components/bolt/login/countryDropdown.sss';

// Might be worth moving to base utils ?
async function animateHeight(el, to) {
	if (!el) {
		return;
	}
	// Ensure the element has a transition on the height
	if (!getComputedStyle(el).transitionProperty?.split(/\s*,\s*/).includes('height')) {
		return;
	}
	let from = el.offsetHeight;
	if (to === 'auto') {
		el.style.height = 'auto';
		to = el.offsetHeight;
		el.style.height = '';
	}
	if (from == to) {
		return;
	}
	let promise = pendingPromise();
	el.addEventListener('transitionend', promise.resolve, { once: true });
	el.heightTransitionPromise = promise;
	el.style.height = `${from}px`;
	el.offsetWidth;
	el.style.height = `${to}px`;
	await promise;
	if (el.heightTransitionPromise === promise) {
		el.style.height = '';
		el.heightTransitionPromise = null;
	}
}

// Twemoji:
// const flagImage = country => `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/${[...country.toLowerCase()].map(c => (c.codePointAt(0) + 127365).toString(16)).join('-')}.svg`;
// Flagpack:
const flagpackSpecialNames = { UK: 'GB-UKM', GB: 'GB-UKM' };
const flagImage = country => {
	country = country.toUpperCase();
	let file = flagpackSpecialNames[country] || country;
	return `https://cdn.jsdelivr.net/npm/flagpack-core@2.0.0/svg/l/${file}.svg`;
};

const getCountryName = (() => {
	let translations;
	try {
		let language = __REGION__.split('_')[1] || __REGION__;
		translations = new Intl.DisplayNames(language, { type: 'region' });
	} catch (e) {
		try {
			// Fallback to user language
			translations = new Intl.DisplayNames(undefined, { type: 'region' });
		} catch (e) {}
	}
	return region => {
		try {
			return translations.of(region.toUpperCase());
		} catch (e) {
			return region;
		}
	};
})();

// Move to own folder if we need to reuse
export default class CountryDropdown extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value || props.options[0],
			upwards: false,
		};

		this.open = this.open.bind(this);
		this.close = this.close.bind(this);
		this.checkOptionsPosition = this.checkOptionsPosition.bind(this);
		this.onAnyScroll = this.onAnyScroll.bind(this);
		this.onLabelPointerDown = this.onLabelPointerDown.bind(this);
		this.onFocusIn = this.onFocusIn.bind(this);
		this.onFocusOut = this.onFocusOut.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
		this.selectRegion = this.selectRegion.bind(this);
	}

	get value() {
		return this.state.value;
	}

	componentDidMount() {
		window.addEventListener('resize', this.checkOptionsPosition);
		window.addEventListener('scroll', this.onAnyScroll, true);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.checkOptionsPosition);
		window.removeEventListener('scroll', this.onAnyScroll, true);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			this.setValue(nextProps.value);
		}
	}

	async open() {
		if (this.state.open) {
			return;
		}
		this.setState({ open: true });
		let optionsWrapper = this.base.querySelector(`.${s.optionsWrapper}`);
		optionsWrapper.style.height = 'auto';
		if (this.state.value) {
			optionsWrapper.querySelector(`[value="${this.state.value.replace(/"/g, '')}"]`)?.scrollIntoView({ block: 'nearest' });
		}
		let toHeight = optionsWrapper.offsetHeight;
		this.checkOptionsPosition();
		optionsWrapper.style.height = '';
		// await animateHeight(optionsWrapper, 'auto');
		await animateHeight(optionsWrapper, toHeight);
	}

	async close() {
		if (!this.state.open) {
			return;
		}
		this.setState({ open: false });
		await animateHeight(this.base.querySelector(`.${s.optionsWrapper}`), 0);
	}

	setValue(value) {
		this.setState({ value });
		if (this.state.open) {
			this.base.querySelector(`[value="${value.replace(/"/g, '')}"]`)?.scrollIntoView({ block: 'nearest' });
		}
	}

	checkOptionsPosition() {
		if (!this.state.open) {
			return;
		}
		let options = this.base.querySelector(`.${s.optionsWrapper}`);
		let baseRect = this.base.getBoundingClientRect();
		let shouldBeUpwards = baseRect.bottom + options.offsetHeight > window.innerHeight;
		if (this.state.upwards !== shouldBeUpwards) {
			this.setState({ upwards: shouldBeUpwards });
		}
	}

	selectRelative(offset) {
		const options = this.props.options;
		let active = options.indexOf(this.state.value);
		if (active === -1 && offset < 0) {
			active = 0;
		}
		this.selectRegion(options.at((active + offset) % options.length), true);
	}

	onAnyScroll(e) {
		if (!this.state.open) {
			return;
		}
		if (!e.target.contains(this.base)) {
			return;
		}
		this.checkOptionsPosition();
	}

	onLabelPointerDown(e) {
		if (this.state.open && this.base.contains(document.activeElement)) {
			document.activeElement.blur();
			e.preventDefault();
		} else {
			const { client } = this.props;
			if (client.isSafari) {
				this.onFocusIn();
			}
		}
	}

	onFocusIn() {
		this.open();
	}

	onFocusOut(e) {
		if (this.base.contains(e.relatedTarget)) {
			return;
		}
		this.close();
	}

	onKeyDown(e) {
		if (!this.state.open) {
			return;
		}
		switch (e.key) {
			case 'ArrowUp':
			case 'ArrowLeft':
				e.preventDefault();
				this.selectRelative(-1);
				break;
			case 'ArrowDown':
			case 'ArrowRight':
				e.preventDefault();
				this.selectRelative(1);
				break;
			case 'Enter':
			case 'Escape':
				e.preventDefault();
				if (this.base.contains(document.activeElement)) {
					document.activeElement.blur();
				}
				break;

		}
	}

	selectRegion(region, doNotClose) {
		if (region === this.state.value) {
			return;
		}
		this.setValue(region);
		if (!doNotClose) {
			document.activeElement.blur();
			const { client } = this.props;
			if (client.isSafari) {
				this.close();
			}
		}
		this.props.onChange?.({ target: this });
	}

	renderButtonContent(region) {
		return [
			<img class={s.icon} src={flagImage(region)} width="32" height="24" alt="" role="presentation" key="icon" />,
			<span class={s.name} key="name">{getCountryName(region)}</span>,
		];
	}

	render({ options, class: className }, { value, open, upwards }) {
		if (!options?.length) {
			throw new Error('Invalid usage of CountryDropdown');
		}
		return (
			<div
				class={joinClasses(s.dropdown, open && s.open, upwards && s.upwards, className)}
				onFocusIn={this.onFocusIn}
				onFocusOut={this.onFocusOut}
				onKeyDown={this.onKeyDown}
			>
				<button class={s.label} onPointerDown={this.onLabelPointerDown}>
					<span class={s.chevron} />
					{this.renderButtonContent(value)}
				</button>
				<div class={s.optionsWrapper}>
					<div class={s.options}>
						{options.map(region => (
							<button
								class={joinClasses(s.option, region === value && s.selected)}
								onClick={region === value ? this.close : () => this.selectRegion(region)}
								// controlled via up/down keys
								tabIndex="-1"
								value={region}
								key={region}
							>
								{this.renderButtonContent(region)}
							</button>
						))}
					</div>
				</div>
			</div>
		);
	}
}